module.exports = __webpack_public_path__ + "media/project_01.4905930f.mp4";